import { DEFAULT_TAX_RATE, getTradeTaxRate } from "../constants/tax";
import { agentRowMatchesUser } from "./dashboardStatsUtils";
import { roundTo2 } from "./numberUtils";
import { computeOfficeExpenses } from "./officeExpenses";

function tradeAddress(trade) {
  const k = trade?.keyInfo || {};
  return [k.streetNumber, k.streetName, k.unit].filter(Boolean).join(" ");
}

function tradeDateIso(trade) {
  const k = trade?.keyInfo || {};
  const raw = k.closeDate || k.firmDate || k.offerDate || "";
  if (raw) return String(raw).slice(0, 10);
  if (trade?.createdAt) return String(trade.createdAt).slice(0, 10);
  return "";
}

export function formatDeductionMoney(value) {
  const n = roundTo2(Number(value) || 0);
  return `$${n.toLocaleString("en-CA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function buildOfficeDeductionsRows(
  trades,
  { appUser = null, fromDate = "", toDate = "" } = {},
) {
  const rows = [];
  for (const trade of trades || []) {
    const dateIso = tradeDateIso(trade);
    if (fromDate && dateIso && dateIso < fromDate) continue;
    if (toDate && dateIso && dateIso > toDate) continue;
    if (fromDate && !dateIso) continue;
    if (toDate && !dateIso) continue;

    const taxRate = getTradeTaxRate(trade) || DEFAULT_TAX_RATE;
    for (const agent of trade.agentCommissionList || []) {
      if (appUser && !agentRowMatchesUser(agent, appUser)) continue;
      const computed = computeOfficeExpenses(agent, taxRate);
      if (!computed.items.length) continue;
      for (const item of computed.items) {
        rows.push({
          tradeId: String(trade._id || ""),
          tradeNumber: trade.tradeNumber ?? trade.keyInfo?.tradeNumber ?? "",
          date: dateIso,
          address: tradeAddress(trade),
          agentName: agent.agentName || "",
          agentId: agent.agentId || "",
          expenseKey: item.key,
          expenseLabel: item.label,
          amount: item.amount,
          tax: item.tax,
          total: item.total,
        });
      }
    }
  }

  rows.sort((a, b) => {
    const numA = parseInt(a.tradeNumber, 10) || 0;
    const numB = parseInt(b.tradeNumber, 10) || 0;
    if (numA !== numB) return numB - numA;
    const agentCmp = String(a.agentName).localeCompare(String(b.agentName));
    if (agentCmp) return agentCmp;
    return String(a.expenseLabel).localeCompare(String(b.expenseLabel));
  });
  return rows;
}

export function officeDeductionsTotals(rows) {
  return (rows || []).reduce(
    (acc, row) => ({
      amount: roundTo2(acc.amount + (Number(row.amount) || 0)),
      tax: roundTo2(acc.tax + (Number(row.tax) || 0)),
      total: roundTo2(acc.total + (Number(row.total) || 0)),
    }),
    { amount: 0, tax: 0, total: 0 },
  );
}
